const liveStatusEnum = {
    CLOSE: 'close',
    OPEN: 'open',
    BAN: 'ban'
}


export default liveStatusEnum;